import { Component } from '@angular/core';
import { NavigService } from 'src/app/services/navig.service';

@Component({
  selector: 'app-specialistes',
  templateUrl: './specialistes.component.html',
  styleUrls: ['./specialistes.component.scss']
})
export class SpecialistesComponent {
  constructor(
    public nav : NavigService
  ){}

}
